var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 579",
    clipPath: "url(#clip0_23054_537910)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 7.66634C9.73543 7.66634 9.48108 7.56098 9.29354 7.37345C9.10601 7.18591 9.00065 6.93156 9.00065 6.66634C9.00065 6.40112 9.10601 6.14677 9.29354 5.95923C9.48108 5.7717 9.73543 5.66634 10.0007 5.66634C10.2659 5.66634 10.5202 5.7717 10.7078 5.95923C10.8953 6.14677 11.0007 6.40112 11.0007 6.66634C11.0007 6.93156 10.8953 7.18591 10.7078 7.37345C10.5202 7.56098 10.2659 7.66634 10.0007 7.66634ZM10.834 13.8622C10.834 14.0832 10.7462 14.2951 10.5899 14.4514C10.4336 14.6077 10.2217 14.6955 10.0007 14.6955C9.77964 14.6955 9.56768 14.6077 9.4114 14.4514C9.25512 14.2951 9.16732 14.0832 9.16732 13.8622V9.69551C9.16732 9.47449 9.25512 9.26253 9.4114 9.10625C9.56768 8.94997 9.77964 8.86217 10.0007 8.86217C10.2217 8.86217 10.4336 8.94997 10.5899 9.10625C10.7462 9.26253 10.834 9.47449 10.834 9.69551V13.8622ZM10.0007 0.833008C4.93815 0.833008 0.833984 4.93717 0.833984 9.99967C0.833984 15.0622 4.93815 19.1663 10.0007 19.1663C15.0632 19.1663 19.1673 15.0622 19.1673 9.99967C19.1673 4.93717 15.0632 0.833008 10.0007 0.833008Z",
    fill: "#C9C9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23054_537910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltipIcon.66707a4e31d5c783705f61bc3ebba096.svg";
export { ForwardRef as ReactComponent };